import { TJsonQuery } from '../../../../../packages/JsonQuery';
import { mlSearchSession } from 'shared/mlSearchSession';

interface IParams {
  totalOffers: number;
  jsonQuery: TJsonQuery;
}

export const prepareGaExtra = ({ totalOffers, jsonQuery }: IParams) => {
  const mlSearchSessionGuid = mlSearchSession.getSessionGuid(jsonQuery);

  return JSON.stringify({
    mlSearchSessionGuid,
    sc: jsonQuery,
    offersQty: totalOffers,
  });
};
